// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-search-relation .inputSearch{
    background-color: #0166a0 !important;
}
.cont-search-relation .inputSearch:focus, .cont-search-relation .inputSearch:hover {
    
    color: aliceblue !important;
  }
.body_info_cis_relation {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .cont-cis-table-relation {
    position: relative;
    height: 90%;
    width: 100%;
    /* background: rgba(195,195,195);
    background: #003757; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-cis_relation {
    position: relative;
    justify-content: center;
    display: block;
    height: 98%;
    width: 94%;
    border-radius: 10px;
    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */
    /* border: 2px solid #003757; */
    border-radius: 10px;
  }

  .cont-search-relation {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 35%;
  }
  
  .content-card-cis-relation {
    position: relative;
    height: 100%;
    width: 100%;
    display: block;
    justify-content: center;
    align-items: center;
    border: 1px solid #003757;
    border-radius: 10px;
  }

  .cont-elemen-relation{
    position: relative;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .elemen-relation{
    position: relative;
    width: 85%;
    height: 70%;
    border-radius: 10px;
    border:2px solid #003757;
    display: flex;

  }

  .con-elemen-relation-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 100%;
    color: #003757;
  }
  .con-elemen-relation-img{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10%;
    height: 100%;
  }
  .img-relation:hover{
    cursor: pointer;
  }
  .msgErrorRelation{
    color: red;
  }`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/styles/ModalCisAfecta.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;;IAEI,2BAA2B;EAC7B;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;0BACsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,2FAA2F;IAC3F,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ","sourcesContent":[".cont-search-relation .inputSearch{\n    background-color: #0166a0 !important;\n}\n.cont-search-relation .inputSearch:focus, .cont-search-relation .inputSearch:hover {\n    \n    color: aliceblue !important;\n  }\n.body_info_cis_relation {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n  .cont-cis-table-relation {\n    position: relative;\n    height: 90%;\n    width: 100%;\n    /* background: rgba(195,195,195);\n    background: #003757; */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .content-cis_relation {\n    position: relative;\n    justify-content: center;\n    display: block;\n    height: 98%;\n    width: 94%;\n    border-radius: 10px;\n    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */\n    /* border: 2px solid #003757; */\n    border-radius: 10px;\n  }\n\n  .cont-search-relation {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 35%;\n  }\n  \n  .content-card-cis-relation {\n    position: relative;\n    height: 100%;\n    width: 100%;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #003757;\n    border-radius: 10px;\n  }\n\n  .cont-elemen-relation{\n    position: relative;\n    width: 100%;\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n  }\n  .elemen-relation{\n    position: relative;\n    width: 85%;\n    height: 70%;\n    border-radius: 10px;\n    border:2px solid #003757;\n    display: flex;\n\n  }\n\n  .con-elemen-relation-info{\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    height: 100%;\n    color: #003757;\n  }\n  .con-elemen-relation-img{\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 10%;\n    height: 100%;\n  }\n  .img-relation:hover{\n    cursor: pointer;\n  }\n  .msgErrorRelation{\n    color: red;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
